import { render, staticRenderFns } from "./CouponType.vue?vue&type=template&id=54d45412"
import script from "./CouponType.vue?vue&type=script&lang=js"
export * from "./CouponType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports